import { BillStatus } from "@common/types/bill";
import {
    BillView,
    BillLineItemView,
    BillsByVendorView,
} from "@common/types/views/billViews";
import { NamedView } from "@common/types/views/views";
import { useMemo } from "react";
import { DATE_RANGE_PRESETS_BY_ID } from "@helpers/date";
import { useConstant } from "@hooks/useConstant";
import { createAccrualReviewBillLineItemsView } from "./AccrualReviewBillLineItemsView";
import {
    defaultBillsView,
    createDefaultBillLineItemsView,
    defaultBillsByVendorView,
} from "./defaultBillViews";

const LEDGER_REVIEW_FILTERS = {
    externalBillStatuses: [BillStatus.DRAFT, BillStatus.OPEN, BillStatus.PAID],
};

const ledgerReviewBillView: NamedView<BillView> = {
    ...defaultBillsView,
    id: "ledger-review",
    name: "Ledger review",
    filters: LEDGER_REVIEW_FILTERS,
};

const ledgerReviewBillsByVendorView: NamedView<BillsByVendorView> = {
    ...defaultBillsByVendorView,
    id: "ledger-review",
    name: "Ledger review",
    filters: LEDGER_REVIEW_FILTERS,
};

const BUILT_IN_BILL_VIEWS: Array<NamedView<BillView>> = [ledgerReviewBillView];
const BUILT_IN_BILLS_BY_VENDOR_VIEWS: Array<NamedView<BillsByVendorView>> = [
    ledgerReviewBillsByVendorView,
];

export function useBuiltInBillViews() {
    return BUILT_IN_BILL_VIEWS;
}

export const createBuiltInBillLineItemViews = ({
    hasAnyAccrualLedgers,
    today,
}: {
    hasAnyAccrualLedgers: boolean;
    today: Date;
}): Array<NamedView<BillLineItemView>> => {
    const last30Days = DATE_RANGE_PRESETS_BY_ID.last_30_days;
    return [
        {
            ...createDefaultBillLineItemsView({ hasAnyAccrualLedgers }),
            id: "ledger-review",
            name: "Ledger review",
            filters: LEDGER_REVIEW_FILTERS,
        },
        ...(hasAnyAccrualLedgers
            ? [
                  createAccrualReviewBillLineItemsView({
                      start: last30Days.getStart(today),
                      end: last30Days.getEnd(today),
                  }),
              ]
            : []),
    ];
};

export function useBuiltInBillLineItemViews(hasAnyAccrualLedgers: boolean) {
    const today = useConstant(() => new Date());
    return useMemo(
        () =>
            createBuiltInBillLineItemViews({
                hasAnyAccrualLedgers,
                today,
            }),
        [hasAnyAccrualLedgers, today],
    );
}

export function useBuiltInBillsByVendorViews() {
    return BUILT_IN_BILLS_BY_VENDOR_VIEWS;
}
